<template>
  <div class="d-flex align-items-center body-2 text-nowrap mr-4">
    <VIcon class="mr-3">
      mdi-account-multiple
    </VIcon>
    <span class="body-2 textPrimary--text">{{ getPassengersSummary }}</span>
  </div>
</template>

<script lang="ts">
export default {
  name: 'PassengersSummary',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '../../../composables';

const props = defineProps({
  adults: {
    type: Number,
    default: null,
  },
  children: {
    type: Number,
    default: null,
  },
});

const { t } = useI18n();

const getPassengersSummary = computed(() => {
  const adult = `${ props.adults > 1 ? t('bookingForm.adultsSummary', { adults: props.adults }) : t('bookingForm.adultSummary')}`;
  const children = `${ props.children > 1 ? t('bookingForm.childrenSummary', { children: props.children }) : t('bookingForm.childSummary')}`;
  if (props.adults && props.children) {
    return `${adult}, ${children}`;
  }
  if (props.adults) {
    return adult;
  }
  return children;
});
</script>

